<div class="form-header">
 {{eventMode}} calendar event
</div>
<div class="body" *ngIf="panel === 0">
  <div class="tabs" *ngIf="cachedEvents.length > 1">
    <button *ngFor="let cachedEvent of cachedEvents; index as n;"mat-button class="body-standard-tab" [ngClass]="{selected: tabIndex == n}" (click)="setTab(n)">Appointment {{n+1}}</button>
  </div>
</div>
<form  [ngClass]="{'justified-flex-small': isRequest(), 'justified-flex-tabs': cachedEvents.length > 1, 'justified-flex': !isRequest()}" [formGroup]="eventForm" (ngSubmit)="onSubmitForm(eventForm)">
  <div class="dialog-container" *ngIf="panel === 0">
    <div class="field">
      <mat-form-field>
        <mat-select name="eventType" formControlName="eventType" (selectionChange)="onEventTypeChanged($event.value)" placeholder="Event Type">
          <mat-option *ngFor="let eventType of eventTypes" [value]="eventType">{{eventType}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="field">
      <mat-form-field>
        <mat-select name="status" formControlName="status" placeholder="Status">
          <mat-option *ngFor="let status of activeStatuses" [value]="status">{{status.replaceAll('_', ' ')}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="family-descriptor" *ngIf="isAppointment() && eventMode === 'Edit'">

        Family: <b>{{sanitizeIdentifier(data.appointment.familyIdentifier, data.appointment.familyIdentifier)}}</b> Contact: <b>{{sanitizeNamedPrimary(data.appointment.familyIdentifier, data.appointment.familyPrimary)}}</b>

    </div>
    <div  *ngIf="isAppointment() && eventMode != 'Edit'">
      <div class="panel-body">
        <mat-form-field class="full-field">  
          <button class="search-icon" (click)="getPageOfFamilies($event)"  matPrefix mat-button><mat-icon>search</mat-icon></button>
          <input type="text" (input)="getPageOfFamilies($event)" formControlName="familySearchIdentifier" name="familySearchIdentifier" matInput placeholder="Search for a family" [matAutocomplete]="auto">
          <mat-autocomplete  (optionSelected)="familySelected($event)" #auto="matAutocomplete">
            <mat-option *ngFor="let family of families" [value]="family.identifier">{{family.identifier}} {{family.namedPrimary}} ({{family.serviceLevel}})</mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div> 
    </div>

    <div class="field">
      <mat-form-field>
        <mat-select name="team" formControlName="team" placeholder="Select Team">
          <mat-option *ngFor="let t of getTeams()" [value]="t">{{t.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select [disabled]="!getTeam()" name="teamMember" formControlName="teamMember" placeholder="Select Team Member">
          <mat-option *ngFor="let member of getCapableTeamMembers()" [value]="member">{{member.email}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="field" required *ngIf="isAppointment()">
      <mat-form-field>
        <mat-select name="servicesRequired" formControlName="servicesRequired" placeholder="Services Required" multiple>
          <mat-option *ngFor="let service of serviceLevelServices" [value]="service">{{service}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div> 
    <div class="date-bar">
      <div class="field-date" required>
        <mat-form-field>
          <mat-label>Start</mat-label>
          <input matInput name="startDt" formControlName="startDt" [owlDateTimeTrigger]="startDtPicker"
            [owlDateTime]="startDtPicker"  >
          <owl-date-time (afterPickerClosed)="handleDateChanged('start')" #startDtPicker stepMinute="5"></owl-date-time>
        </mat-form-field>
      </div>

      <div class="field-date" required>
        <mat-form-field>
          <mat-label>End</mat-label>
          <input matInput  name="endDt" formControlName="endDt" [owlDateTimeTrigger]="endDtPicker" [owlDateTime]="endDtPicker">
          <owl-date-time  (afterPickerClosed)="handleDateChanged('end')"  #endDtPicker stepMinute="5"></owl-date-time>
        </mat-form-field>
      </div>
      <div class="field-smaller" *ngIf="isRequestedStatus() ">
        <div class="stacked-items" >
          <mat-slide-toggle name="allDay" (change)="handleDateChanged('allDay')" formControlName="allDay">All day</mat-slide-toggle> 
        </div>
      </div>
    </div>

    <div class="full-field">
      <mat-form-field>
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description" name="description" placeholder="Add description here" rows="4" maxlength="512"></textarea>
      </mat-form-field>
    </div>  
  </div>
  <div *ngIf="panel === 1 && isAppointment()" class="inter-panel">
    <div class="fields" *ngIf="isRequestedStatus()" >
      <div class="availability-list">
        <div class="list-item" *ngFor="let candidate of candidates"> 
          <div class="appointment-container">
            <div class="appointment" *ngFor="let appointment of candidate.appointments">
              {{toAppointmentFormat(appointment.startDateTime, appointment.endDateTime)}} {{getTeamMemberNameFromId(appointment.teamMemberId)}}
            </div>               
          </div>
          <button  class="add-button" color="primary" (click)="createFromCandidate(candidate)" mat-icon-button type="button">
            <mat-icon>add_circle</mat-icon>
          </button>
        </div>
      </div>
    </div>  
  </div>
  <div *ngIf="panel === 2 && isAppointment() && !isRequestedStatus()">
   <div class="checklist-container">
      <div class="date-bar" *ngIf="canEditProtocol()">
        <div class="field-three-quarters">
          <mat-form-field>
            <mat-select name="checklistTemplate" formControlName="checklistTemplate" placeholder="Import checklist" > 
              <mat-option *ngFor="let checklistTemplate of checklistTemplates" [value]="checklistTemplate.id">{{checklistTemplate.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <button  color="primary"  mat-button type="button" (click)="importChecklistTemplate()">
          Import
        </button>
      </div>
      <div class="services-list">
        <table mat-table [dataSource]="checklistItems" class="checklist-table">
          <tr mat-header-row *matHeaderRowDef="displayChecklistColumns"></tr>
          <tr mat-row *matRowDef="let row; let i = index; columns: displayChecklistColumns;"></tr>
          <ng-container matColumnDef="item">
            <th mat-header-cell *matHeaderCellDef>Item / Service</th>
            <td mat-cell *matCellDef="let element; let index = index"  >
                <span>{{element.value.item}}</span> <br>
                <span class="in-cell-title">{{getServiceNameForId(element.value.service)}}</span>      <br>

                <mat-chip-list *ngIf="element.value.required"> 
                  <mat-chip color="accent" selected>Required</mat-chip>
                </mat-chip-list> 
                <!-- <textarea class="ckl-item" rows="3" [formControl]="getControl(index,'item')" maxlength="50" placeholder="Add an item"></textarea><br> -->

                <!-- <mat-select class="ckl-item" name="service" [formControl]="getControl(index,'service')" placeholder="Service">
                  <mat-option *ngFor="let service of getServicesForChecklist()" [value]="service.id">{{service.name}}</mat-option>
                </mat-select> -->
             
            </td>
          </ng-container>
          <ng-container matColumnDef="workerScore">
            <th mat-header-cell *matHeaderCellDef> Worker score / notes</th>
            <td  mat-cell *matCellDef="let element; let index = index"  > 
              <span class="in-cell-title" *ngIf="element.value.required">Score (0-10):&nbsp;{{element.value.workerScore}}</span>
              <br>
              <span class="workerNotes">{{element.value.workerNotes}}</span>
             </td>
          </ng-container>


          <ng-container matColumnDef="workerScoreEntry">
            <th mat-header-cell *matHeaderCellDef> Score / Notes</th>
            <td  mat-cell *matCellDef="let element; let index = index"  > 

              <span class="in-cell-title" *ngIf="element.value.required">Score (0-10)&nbsp;</span>
              <mat-slider  *ngIf="element.value.required"          
                  class="ckl-score" max="10" min="0" step="1" showTickMarks="true" disabled="false"
                   >
                  <input matSliderThumb [formControl]="getControl(index,'workerScore')">
              </mat-slider>
              <br>
              <textarea class="workerNotesEntry" [formControl]="getControl(index,'workerNotes')" maxlength="512" rows="3" columns="15" placeholder="Add some notes"></textarea>
             </td>
          </ng-container>
          <ng-container matColumnDef="coordScore">
            <th mat-header-cell *matHeaderCellDef> Coordinator Score </th>
            <td mat-cell *matCellDef="let element; let index = index"  > 

              <span class="in-cell-title" *ngIf="element.value.required">Score (0-10)&nbsp;</span>
              <mat-slider   *ngIf="element.value.required"            
              class="ckl-score" max="10" min="0" step="1" showTickMarks="true" disabled="false"
                  >     
                      <input matSliderThumb [formControl]="getControl(index,'coordScore')">
              </mat-slider>
          <br>
              <textarea class="coordNotes" [formControl]="getControl(index,'coordNotes')" maxlength="512" rows="3"  columns="15"  placeholder="Add some notes"></textarea>
             </td>
          </ng-container>
          

  
        </table>
      </div>
      <div class="total-score-line">
        <div class="total-score"><b>Total Score:</b> {{getTotalScore()}} / {{getTotalPossible()}}</div>
        <div class="total-score" ><b>Coordinator Total Score:</b> {{getCoordTotalScore()}} / {{getTotalPossible()}}</div>    
      </div>
    </div>
  </div>  
  <div *ngIf="panel === 3 && isAppointment()" class="inter-panel">    
    <div class="full-field">
      <mat-form-field>
        <mat-label>Notes</mat-label>
        <textarea matInput formControlName="notes" name="notes" placeholder="Add notes here" rows="9" maxlength="2048"></textarea>
      </mat-form-field>
    </div>  
  </div>  
  <div class="button-container">
      <button class="dialog-button" [disabled]="!isFormValid()" type="submit" mat-flat-button color="primary" >Save</button>
      <button class="dialog-button" *ngIf="isAppointment() && isRequestedStatus() && panel === 0"  [disabled]="!canGetCandidates()" type="button" (click)="getCandidates()" mat-flat-button color="primary" >Show Available</button>
      <button class="dialog-button" *ngIf="isAppointment() && !isRequestedStatus() && panel === 2" type="button" (click)="panel = 3" mat-flat-button color="primary" >Add Notes</button>
      <button class="dialog-button" *ngIf="isAppointment() && panel> 0"  type="button" (click)="showBaseInformation()" mat-flat-button color="primary" >Base Information</button>
      <button class="dialog-button" *ngIf="isAppointment() && !isRequestedStatus()  && panel  != 2 "   type="button" (click)="showTrackProgress()" mat-flat-button color="primary" >Track Progress</button>
    <button class="dialog-button" mat-flat-button color="primary" type="reset" (click)="close()">Cancel</button>
  </div>
</form>